import DepartementArtsDivTemplate from './DepartementArtsDivTemplate';
import departementData from '../../data/departements/arts-div/75';
export default function Departement75ParisArtsDiv() {
  return <DepartementArtsDivTemplate data={departementData} />;
}
